import axios from "../axios/axios";
import { setUsers } from "../store/actions/userAction";
import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { setAction, setEditItem, setIndex, updateFormStatus } from "../store/actions/formAction";
import { setUserFormData } from "../helpers/FormDataCreator";
import { errorDispatcher, setSelectItemLabels } from "../helpers";

export const apiGetUser = (userId, token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`users/show/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      let user = response.data.user;
      user.ePhone = user.phone ?? user.email;
      user = {
        ...user,
        ...user.accessTimeLimit,
      };

      dispatch(setEditItem(user));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetUsers = (token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get("users", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const users = setSelectItemLabels(
        response.data.users,
        "id",
        (user) => `${user.firstName} ${user.lastName}`
      );
      dispatch(setUsers(users));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiDeleteUser = (userId, token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .delete("users", {
      headers: { Authorization: `Bearer ${token}` },
      data: { userId },
    })
    .then((response) => {
      dispatch(apiGetUsers(token));
      dispatch(apiSetAlert(response.data.message, "success"));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddUsers = (forms, token, navigate) => async (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  dispatch(setAction("save"));
  apiAddUser(dispatch, forms, token, 0, navigate);
};

export const apiAddUser = (dispatch, forms, token, index, navigate, errorIndex = null, fd, cb, err) => {
  const form = forms[index];

  const nextApi = () => {
    if (index + 1 < forms.length) {
      apiAddUser(dispatch, forms, token, index + 1, navigate, errorIndex);
    } else {
      dispatch(appSetSendingRequest(false));
      if (errorIndex !== null && form && form[errorIndex]) {
        dispatch(setAction("filling"));
        dispatch(apiSetAlert(forms[errorIndex].errors, "error"));
        dispatch(setIndex(forms[errorIndex].index));
      } else if (navigate) {
        navigate("/users");
      }
    }
  };

  if (form?.status !== "saved" || fd) {
    dispatch(setIndex(form?.index));
    dispatch(updateFormStatus("saving"));
    const formData = form ? setUserFormData(form) : fd;
    axios
      .post("/users", fd || formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(updateFormStatus("saved"));
        cb && cb(response.data);
        nextApi();
      })
      .catch((error) => {
        errorIndex = index;
        dispatch(updateFormStatus("error", error?.response?.data?.message));
        errorDispatcher(error, dispatch);
        nextApi();
      });
  } else {
    nextApi();
  }
};

export const apiUpdateUser = (personId, form, token, navigate, fd, cb) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  const formData = form ? setUserFormData(form) : fd;
  axios
    .put(`/users/${personId}`, fd || formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      cb && cb(response.data);
      navigate && navigate("/users");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
